<!-- <ihd-plan-premium
    class="mr-4"
    [splitMode]="true"
    [isAnnualMode]="isAnnualMode"
    (changeInterval)="setPlan($event)"
    *ngIf="
        config?.showPlanDetails &&
        upsellTier === SubscriptionTier.PREMIUM &&
        (isIHDSubscription ? currentSubscription.price !== 0 : true)
    "
>
</ihd-plan-premium>
<ihd-plan-starter
    class="mr-4"
    [splitMode]="true"
    [isAnnualMode]="isAnnualMode"
    (changeInterval)="setPlan($event)"
    *ngIf="config?.showPlanDetails && upsellTier === SubscriptionTier.STARTER"
>
</ihd-plan-starter> -->
<ihd-modal class="c-modal--xs c-modal--primary" [createOverlay]="false">
    <div class="c-modal__header">
        <ihd-tabs [items]="tabItems"></ihd-tabs>
        <ihd-button-group class="ml-auto c-btn-group--gap-2">
            <div
                class="c-btn-group__vert-divider--fill c-btn-group__vert-divider"
            ></div>
            <button
                ihdIconButton
                icon="close"
                class="x-modal__icon-btn c-icon-btn--xs"
                (click)="closeDialog()"
            >
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>
    <div class="c-modal__body pb-0">
        <div
            class="c-modal__body-content c-modal__body--no-scroller"
            [formGroup]="billingForm"
            [ihdFormSubmitted]="isSubmitted"
        >
            <div class="c-form-group">
                <div class="l-row">
                    <div class="l-col">
                        <label>{{
                            'Profile.BasicInfo.FirstName' | translate
                        }}</label>
                        <input
                            type="text"
                            formControlName="first_name"
                            class="c-form-control"
                            placeholder="{{
                                'Profile.BasicInfo.FirstName' | translate
                            }}"
                        />
                        <ihd-form-messages
                            [form]="billingForm"
                            name="first_name"
                            [submitted]="isSubmitted"
                        >
                            <ihd-form-message name="required">{{
                                'Common.Error.Required' | translate
                            }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                    <div class="l-col">
                        <label>{{
                            'Profile.BasicInfo.LastName' | translate
                        }}</label>
                        <input
                            type="text"
                            formControlName="last_name"
                            class="c-form-control"
                            placeholder="{{
                                'Profile.BasicInfo.LastName' | translate
                            }}"
                        />
                        <ihd-form-messages
                            [form]="billingForm"
                            name="last_name"
                            [submitted]="isSubmitted"
                        >
                            <ihd-form-message name="required">{{
                                'Common.Error.Required' | translate
                            }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                </div>
            </div>
            <div class="c-form-group">
                <div class="l-row">
                    <div class="l-col">
                        <label>{{
                            'Profile.BasicInfo.Email' | translate
                        }}</label>
                        <input
                            type="email"
                            formControlName="email"
                            class="c-form-control"
                            placeholder="{{
                                'Profile.BasicInfo.Email' | translate
                            }}"
                        />
                        <ihd-form-messages
                            [form]="billingForm"
                            name="email"
                            [submitted]="isSubmitted"
                        >
                            <ihd-form-message name="email">{{
                                'Common.Error.InvalidEmail' | translate
                            }}</ihd-form-message>
                            <ihd-form-message name="required">{{
                                'Common.Error.Required' | translate
                            }}</ihd-form-message>
                        </ihd-form-messages>
                    </div>
                </div>
            </div>
            <fieldset formGroupName="address">
                <div class="c-form-group">
                    <div class="l-row">
                        <div class="l-col-7">
                            <label>{{
                                'Billing.Details.Address' | translate
                            }}</label>
                            <input
                                type="text"
                                formControlName="line1"
                                class="c-form-control"
                                placeholder="{{
                                    'Profile.BasicInfo.Address.Line1'
                                        | translate
                                }}"
                            />
                            <ihd-form-messages
                                [form]="billingForm"
                                name="address"
                                [submitted]="isSubmitted"
                            >
                                <ihd-form-message name="line1">{{
                                    'Common.Error.Required' | translate
                                }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-5">
                            <label>{{
                                'Billing.Details.City' | translate
                            }}</label>
                            <input
                                type="text"
                                formControlName="city"
                                class="c-form-control"
                                placeholder="{{
                                    'Profile.BasicInfo.Address.City' | translate
                                }}"
                            />
                            <ihd-form-messages
                                [form]="billingForm"
                                name="address"
                                [submitted]="isSubmitted"
                            >
                                <ihd-form-message name="city">{{
                                    'Common.Error.Required' | translate
                                }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                    </div>
                </div>
                <div class="c-form-group c-form-group--divider">
                    <div class="l-row">
                        <div class="l-col-4">
                            <label>{{
                                'Billing.Details.State' | translate
                            }}</label>
                            <input
                                type="text"
                                formControlName="state"
                                class="c-form-control"
                                placeholder="{{
                                    'Profile.BasicInfo.Address.State'
                                        | translate
                                }}"
                            />
                            <ihd-form-messages
                                [form]="billingForm"
                                name="address"
                                [submitted]="isSubmitted"
                            >
                                <ihd-form-message name="state">{{
                                    'Common.Error.Required' | translate
                                }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-3">
                            <label>{{
                                'Billing.Details.PostalCode' | translate
                            }}</label>
                            <input
                                type="text"
                                formControlName="postal_code"
                                class="c-form-control"
                                placeholder="{{
                                    'Profile.BasicInfo.Address.ZipCode'
                                        | translate
                                }}"
                            />
                            <ihd-form-messages
                                [form]="billingForm"
                                name="address"
                                [submitted]="isSubmitted"
                            >
                                <ihd-form-message name="postalCode">{{
                                    'Common.Error.Required' | translate
                                }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                        <div class="l-col-5">
                            <label>{{
                                'Billing.Details.Country' | translate
                            }}</label>
                            <input
                                type="text"
                                formControlName="country"
                                class="c-form-control"
                                placeholder="{{
                                    'Profile.BasicInfo.Address.Country'
                                        | translate
                                }}"
                            />
                            <ihd-form-messages
                                [form]="billingForm"
                                name="address"
                                [submitted]="isSubmitted"
                            >
                                <ihd-form-message name="country">{{
                                    'Common.Error.Required' | translate
                                }}</ihd-form-message>
                            </ihd-form-messages>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="c-form-group" *ngIf="isIHDSubscription">
                <label>{{ 'Billing.Details.PaymentMethod' | translate }}</label>
                <div
                    ihdRadioGroup
                    [value]="paymentMethod"
                    (change)="setPaymentType($event.value)"
                >
                    <ihd-radio-button
                        [value]="BillingPaymentType.ACH"
                        class="mb-2 mr-4"
                    >
                        {{ 'Billing.Details.PaymentMethod.ACH' | translate }}
                    </ihd-radio-button>

                    <ihd-radio-button [value]="BillingPaymentType.CREDIT_CARD">
                        {{
                            'Billing.Details.PaymentMethod.CreditCard'
                                | translate
                        }}
                    </ihd-radio-button>
                </div>
            </div>
            <ng-container *ngIf="isCreditCardPayment; else IHDConnect">
                <div
                    class="c-form-group c-form-group--divider"
                    *ngIf="!isStripeInitError; else stripeError"
                >
                    <div class="l-row">
                        <div class="l-col-sm-5">
                            <label>{{
                                'Billing.Details.CardNumber' | translate
                            }}</label>
                            <div
                                id="card-number"
                                class="c-form-control c-form-control--stripe"
                            ></div>
                        </div>

                        <div class="l-col-sm-4">
                            <label>{{
                                'Billing.Details.Expiry' | translate
                            }}</label>
                            <div
                                id="card-expiry"
                                class="c-form-control c-form-control--stripe"
                            ></div>
                        </div>

                        <div class="l-col-sm-3">
                            <label>{{
                                'Billing.Details.CVC' | translate
                            }}</label>
                            <div
                                id="card-cvc"
                                class="c-form-control c-form-control--stripe"
                            ></div>
                        </div>
                    </div>
                </div>
                <ng-template #stripeError>
                    <div class="c-alert c-alert--warning text-left">
                        <div class="c-alert__container">
                            <ihd-icon
                                class="c-icon--warning-bubble c-alert__icon align-self-center pl-0 mr-3"
                                name="bell"
                            ></ihd-icon>

                            <div class="c-alert__body">
                                <div class="c-alert__title">
                                    {{ 'Errors.Stripe.Title' | translate }}
                                </div>
                                <div
                                    class="c-alert__description"
                                    [innerHtml]="stripeErrorDesc"
                                ></div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
            <ng-template #IHDConnect>
                <div class="c-form-group">
                    <div class="c-dialog-subscribe__direct-debit">
                        <div class="l-row l-row--no-gutters">
                            <ng-container
                                *ngIf="accountDetails; else connectAccount"
                            >
                                <div class="l-col-12">
                                    <ihd-media
                                        class="c-media--modal-header c-media__icon--circle c-media__icon--success"
                                        media="check"
                                        [heading]="
                                            'Order.Debit.PaymentMethod'
                                                | translate
                                        "
                                    >
                                        <div media-body>
                                            {{
                                                'Order.Debit.Connected'
                                                    | translate
                                            }}
                                        </div>
                                    </ihd-media>
                                </div>
                                <div class="l-col-12 mt-4">
                                    <div class="label--muted">
                                        {{
                                            accountDetailsMetadata.institution
                                                ?.name | uppercase
                                        }}
                                        -
                                        {{
                                            accountDetailsMetadata.account?.name
                                        }}
                                        ({{
                                            accountDetailsMetadata.account
                                                ?.mask
                                        }})
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #connectAccount>
                                <div class="l-col-8">
                                    <ihd-media
                                        class="c-media--modal-header c-media__icon--circle c-media__icon--direct-debit"
                                        media="card"
                                        [heading]="
                                            'Order.Debit.PaymentMethod'
                                                | translate
                                        "
                                    >
                                        <div media-body>
                                            {{
                                                'Order.Debit.Setup' | translate
                                            }}
                                        </div>
                                    </ihd-media>
                                </div>
                                <div class="l-col-4">
                                    <div class="d-flex justify-content-center">
                                        <button
                                            ihdButton
                                            ihdPlaidLink
                                            (connectSuccess)="
                                                setAccountMeta($event)
                                            "
                                            class="c-btn--base-outline c-btn--lg ml-auto"
                                        >
                                            {{
                                                'Order.Debit.Connect'
                                                    | translate
                                            }}
                                        </button>
                                    </div>
                                </div>
                                <div class="l-col-8 mt-3">
                                    {{ 'Order.Debit.Secure' | translate }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
        <div class="c-modal__bottom c-modal__bottom--cta d-flex">
            <button
                ihdButton
                type="button"
                *ngIf="isCreditCardPayment; else submitDirectDebit"
                (click)="submitWithCreditCard()"
                class="c-btn--primary c-btn--lg c-btn--wlg ml-auto"
                [disabled]="
                    (billingForm.invalid && isSubmitted) ||
                    isLoading ||
                    isStripeInitError ||
                    !elements
                "
            >
                {{ submitKey | translate }}
            </button>
            <ng-template #submitDirectDebit>
                <button
                    ihdButton
                    type="button"
                    (click)="submitWithDirectDebit()"
                    class="c-btn--primary c-btn--lg c-btn--wlg ml-auto"
                    [disabled]="
                        (billingForm.invalid && isSubmitted) ||
                        isLoading ||
                        !accountDetailsMetadata
                    "
                >
                    {{ submitKey | translate }}
                </button>
            </ng-template>
        </div>
    </div>
</ihd-modal>
